// extracted by mini-css-extract-plugin
module.exports = {"header":"style-module--header--2JwiS","headerInner":"style-module--headerInner--2KTlF","siteTitle":"style-module--siteTitle--33hGv"};